import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

const selectUserData = (state: RootState) => state.user;

const userDataSelector = createSelector(selectUserData, (userData) => {
  return { userData };
});

const campaignMaxLimitSelector = createSelector(
  selectUserData,
  (userData) => {
    return userData.campaignMaxLimit;
  }
);

export { userDataSelector, campaignMaxLimitSelector };